export default __webpack_public_path__ + "static/media/Swiss-home-banner-liquid-new.0e93274b.jpg";